import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
	selector: 'login-footer',
	templateUrl: './login-footer.component.html',
	styleUrls: ['./login-footer.component.scss'],
})
export class LoginFooterComponent implements OnInit {
	@Output() dataProtectionClick = new EventEmitter<boolean>();

	constructor() {	}

	ngOnInit() { }
}
